if (document.body.id === 'faq') {
    main();
}

function main() {
    const searchInput = document.getElementById('searchbarFaq') as HTMLInputElement;
    const faqCategory = document.querySelectorAll('.faq-category');
    const faqQuestionTab = document.querySelectorAll('.faq-question-tab');
    const noResultsMessage = document.getElementById('no-results-message') as HTMLElement;
    const searchForm = document.querySelector('#faq-search-form') as HTMLFormElement;
    const resetButton = noResultsMessage.querySelector('button') as HTMLButtonElement;

    const removeHideClasses = () => {
        faqQuestionTab.forEach(tab => tab.classList.remove('d-none'));
        faqCategory.forEach(nav => nav.classList.remove('d-none'));
    };

    const filterFaqItems = () => {
        const query = searchInput.value.trim().toLowerCase();

        removeHideClasses();

        let hasVisibleTab = false;

        faqQuestionTab.forEach((tabPane, index) => {
            const questions = tabPane.querySelectorAll('.faq-question');
            let hasVisibleQuestion = false;

            questions.forEach(question => {
                const questionText = question.querySelector('.question-text')?.textContent?.toLowerCase() || '';
                const answerText = question.querySelector('.answer-text')?.textContent?.toLowerCase() || '';

                if (questionText.includes(query) || answerText.includes(query)) {
                    question.classList.remove('d-none');
                    question.querySelector('.answer-text')?.classList.remove('d-none');
                    hasVisibleQuestion = true;
                } else {
                    question.classList.add('d-none');
                    question.querySelector('.answer-text')?.classList.add('d-none');
                }
            });

            if (hasVisibleQuestion) {
                tabPane.classList.remove('d-none');
                faqCategory[index].classList.remove('d-none');
            } else {
                tabPane.classList.add('d-none');
                faqCategory[index].classList.add('d-none');
            }

            hasVisibleTab = hasVisibleTab || hasVisibleQuestion;
        });

        if (!hasVisibleTab) {
            noResultsMessage.classList.remove('d-none');
            faqCategory.forEach(nav => nav.classList.add('d-none'));
            const elements = document.querySelectorAll('.search-hide');
            elements.forEach(element => {
                element.classList.add('d-none');
            });
        } else {
            noResultsMessage.classList.add('d-none');
            const elements = document.querySelectorAll('.search-hide');
            elements.forEach(element => {
                element.classList.remove('d-none');
            });
        }
    };

    const setActiveTab = () => {
        const faqCategoryArray = Array.from(faqCategory);
        let activeCategoryIndex = -1;

        faqCategoryArray.forEach((nav, index) => {
            const faqTab = nav.querySelector('a');
            const faqTabPane = faqQuestionTab[index];

            if (faqTab) {
                faqTab.classList.remove('active');
            }
            if (faqTabPane) {
                faqTabPane.classList.remove('show', 'active');
            }

            if (!nav.classList.contains('d-none') && !nav.classList.contains('active') && activeCategoryIndex === -1) {
                activeCategoryIndex = index;
            }
        });

        if (activeCategoryIndex !== -1) {
            const activeNav = faqCategoryArray[activeCategoryIndex];
            const activeFaqTab = activeNav.querySelector('a');
            const activeTabPane = faqQuestionTab[activeCategoryIndex];

            if (activeFaqTab) {
                activeFaqTab.classList.add('active');
            }

            if (activeTabPane) {
                activeTabPane.classList.add('show', 'active');
            }
        }
    };

    searchForm.addEventListener('submit', (e: Event) => {
        e.preventDefault();
        filterFaqItems();
        setActiveTab();
    });

    resetButton.addEventListener('click', () => {
        searchInput.value = '';
        noResultsMessage.classList.add('d-none');
        const elements = document.querySelectorAll('.search-hide');
        elements.forEach(element => {
            element.classList.remove('d-none');
        });

        faqQuestionTab.forEach(tabPane => {
            tabPane.querySelectorAll('.faq-question').forEach(question => {
                question.classList.remove('d-none');
                const answerText = question.querySelector('.answer-text');
                if (answerText) {
                    answerText.classList.remove('d-none');
                }
            });
        });

        removeHideClasses();
        setActiveTab();
    });
}